<template>
  <div>
    <v-row>
      <v-col>
        <v-card
          elevation="1"
        >
          <v-card-title>請求書出力履歴</v-card-title>
          <v-card-subtitle class="text-right">
            <v-btn
              small
              class="info"
              @click="reload"
            >
              再読み込み
            </v-btn>
          </v-card-subtitle>
          <v-card-text>
            <v-data-table
              :headers="tableHeaders"
              :items="importResults"
              :items-per-page="-1"
              disable-sort
              hide-default-footer
            >
              <template v-slot:[`item.status`]="{ item }">
                <v-chip
                  :color="chipColor(item)"
                  label
                  small
                >
                  {{ item.status_name }}
                </v-chip>
              </template>
              <template v-slot:[`item.created_at`]="{ item }">
                {{ item.created_at | unix_datetime_format }}
              </template>
              <template v-slot:[`item.has_download`]="{ item }">
                <v-btn
                  :disabled="!['completed'].includes(item.status)"
                  small
                  color="primary"
                  @click="downloadClickEvent(item)"
                >
                  ダウンロード
                </v-btn>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>

    <v-row dense>
      <v-col>
        <v-pagination
          v-model="page"
          :length="pagination.total_pages"
          :total-visible="totalVisible"
          circle
          prev-icon="mdi-menu-left"
          next-icon="mdi-menu-right"
          @input="changePage"
        />
      </v-col>
    </v-row>

    
  </div>
</template>

<script>

import { mapActions } from 'vuex'

export default {
  name: 'PdfOutputResults',
  components: {},
  mixins: [],
  props: {
    doReload: {
      type: Number,
      default: () => null,
    }
  },
  data() {
    return {
      page: 1,
      totalVisible: 7,
      pagination: {
        current_page: 1,
        total_count: 0
      },
      tableHeaders: [
        { value: 'status', text: 'ステータス', align: 'center' },
        { value: 'created_at', text: '処理日時' },
        { value: 'file_name', text: 'ファイル名' },
        { value: 'has_download', text: '', align: 'end' },
      ],
      importResults: [],
      importErrorHeaders: [
        { value: 'index', text: '行番号', align: 'start' },
        { value: 'messages', text: '内容', align: 'start' },
      ],
      enableErrorDialog: false,
      importErrorMessages: [],
    }
  },
  computed: {},
  watch: {
    enableErrorDialog () {

    },
    doReload () {
      this.reload()
    }
  },
  created() {
    this.reload()
  },
  methods: {
    ...mapActions('DriverPdfOutputTask', {
      fetchTasks: 'index',
    }),
    ...mapActions('DriverPdfOutputTask', {
      download: 'show',
    }),
    chipColor (item) {
      let color = null
      switch (item.status) {
        case 'standby':
          color = ''
          break
        case 'in_process':
          color = 'secondary'
          break
        case 'completed':
          color = 'primary'
          break
        case 'canceled':
          color = 'orange'
          break
        case 'failure':
          color = 'error'
          break
        default:

      }
      return color
    },
    changePage () {
      this.searchTasks()
    },
    reload () {
      this.page = 1
      this.searchTasks()
    },
    downloadClickEvent (item) {
      /**
       * @typedef content { Object }
       */
      this.download({id: item.id}).then((content) => {
        if (content.billing_url) {
          window.open(content.billing_url, "billingPdfTab");
        }
      })
    },
    closeErrorDialogClickEvent () {
      this.enableErrorDialog = false
    },
    searchTasks () {
      /**
       * @typedef content { Object }
       * @property pdf_output_tasks { Array }
       * @property pagination { Object }
       */
      this.fetchTasks({page: this.page}).then((content) => {
        this.importResults = content.pdf_output_tasks
        this.pagination = content.pagination
      })
    }
  }
}
</script>

<style scoped lang="scss">

</style>
